import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { UserServiceProvider } from '@services/user/user.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'update-package-product-modal',
	template: require('./update-package-product-modal.component.html')
})
export class UpdatePackageProductModalComponent implements OnInit {
	currensySymbol: string;
	numberMask;
	@Output()
	packageProductModalTrigger: EventEmitter<any> = new EventEmitter<any>();
	@Input() modalId: string;
	@Input() modalTitle: string;
	@Input()
	set packageProductData(value) {
		this._packageProductData = value;
		this.initDesc = value.description;
	}

	get packageProductData() {
		return this._packageProductData;
	}

	_packageProductData;
	_btnDisabled: boolean;
	initDesc: string;

	get btnDisabled(): boolean {
		return this._btnDisabled;
	}
	@Input('btnDisabled')
	set btnDisabled(value: boolean) {
		this._btnDisabled = value;
	}

	_name: string;
	get name(): string {
		return this._name;
	}
	@Input('name')
	set name(value: string) {
		this.setDefaultValues();
		this.setNumberMask(value);
		this._name = value;
	}

	constructor(
		private userService: UserServiceProvider,
		private messageService: MessageService
	) {}

	ngOnInit() {}

	setNumberMask(value) {
		this.numberMask = createNumberMask({
			prefix: this.currensySymbol,
			suffix: '',
			allowDecimal: true,
			allowLeadingZeroes: true,
			allowNegative: value === 'Product'
		});
	}

	changeProductPackageText(packageDescription) {
		this.packageProductData.description = packageDescription;
	}

	private setDefaultValues() {
		this.currensySymbol = this.userService.userCurrencySymbol;
	}

	private checkIsProductTemplateType(): void {
		if (this.name === 'Product' && this.packageProductData.price < 0) {
			this.packageProductData.type = 'GIFT';
		}
	}

	private prepareValueToValidate() {
		let { name, description, price, taxType } = JSON.parse(
			JSON.stringify(this.packageProductData)
		);

		name = name.trim();

		price = this.convertAmountIntoNumber(price);

		if (description) {
			const _description = description.replace(/&nbsp;/g, '');
			description = _description.replace(/ /g, '');
		}

		return { name, description, price, taxType };
	}

	convertAmountIntoNumber(value) {
		if (isNaN(value)) {
			const regExp = new RegExp(`[${this.currensySymbol},]`, 'g');
			const a = value.replace(regExp, '');
			return +a;
		}

		return +value;
	}

	private validateModalValue(): boolean {
		let validated = true;
		const { name, description, price, taxType } = this.prepareValueToValidate();

		if (!name || name === '') {
			validated = false;
			this.messageService.showToaster(
				'e_0',
				'productsPackages',
				this.name.toLowerCase()
			);
		} else if (!description || description === '' || description.length === 7) {
			validated = false;
			this.messageService.showToaster(
				'e_3',
				'productsPackages',
				this.name.toLowerCase()
			);
		} else if (!price && price === '') {
			validated = false;
			this.messageService.showToaster(
				'e_2',
				'productsPackages',
				this.name.toLowerCase()
			);
		} else if (!taxType || taxType === '') {
			validated = false;
			this.messageService.showToaster('e_1', 'productsPackages');
		}

		return validated;
	}

	private prepareValueToEmit() {
		this.packageProductData.price = this.convertAmountIntoNumber(
			this.packageProductData.price
		);

		this.packageProductData.name = this.packageProductData.name.trim();

		this.checkIsProductTemplateType();

		return {
			eventType: this.modalTitle,
			data: this.packageProductData
		};
	}

	onSubmit() {
		if (this.validateModalValue()) {
			const modalDataToSend = this.prepareValueToEmit();
			this.packageProductModalTrigger.emit(modalDataToSend);
		}
	}

	dismiss() {
		$(`#${this.modalId}`).modal('hide');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.ts